import { useSelector } from 'react-redux';
import { selectGroups } from 'redux/selectors';
import { useActions } from 'hooks/redux/useActions';
import {
  setGroups,
  setGroupsIfEmpty,
  unsetGroups,
} from 'redux/reducers/groups-reducer';

export function useGroups() {
  const { items: groups, status: groupsStatus } = useSelector(selectGroups);
  const actions = useActions({
    setGroups,
    unsetGroups,
    setGroupsIfEmpty,
  });

  return { groups, groupsStatus, ...actions };
}
